// extracted by mini-css-extract-plugin
export var circle = "ChatBotComponent-module--circle--f3197";
export var fab = "ChatBotComponent-module--fab--e4ab8";